exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.document-container__upload--button[data-v-1d68c06e] {\n  border: 2px inset white;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/block/block-documents/components/block-document-modal/styles.scss"],"names":[],"mappings":";AACE;EACE,wBAAuB;CACxB","file":"styles.scss","sourcesContent":[".document-container {\n  &__upload--button {\n    border: 2px inset white;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d68c06e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/block/block-documents/components/block-document-modal/styles.scss
// module id = gIYq
// module chunks = 0